export default 'customerAcqTrackingPage';
